import { __extends } from "tslib";
import { TaskBaseWebGL } from './TaskBaseWebgGL';
var EMPTY_TRANSFORM = new Float32Array([1, 1, 1, 1, 0, 0, 0, 0]);
var FRAG = "\nprecision highp float;\nuniform vec4 uColorTransform[2];\nvarying vec2 vUv;\n\n/* AGAL legacy attrib resolver require this names */\nuniform sampler2D fs0;\n\nvoid main() {\n\tvec4 color = texture2D(fs0, vUv);\n\n\tif (color.a > 0.0) {\n\t\tcolor.rgb /= color.a;\n\t}\n\n\t// mult\n\tcolor *= clamp(uColorTransform[0], 0.0, 1.0);\t\n\tcolor += uColorTransform[1];\n\n\tcolor.rgb *= color.a;\n\n    gl_FragColor = color;\n}";
var CopyPixelTask = /** @class */ (function (_super) {
    __extends(CopyPixelTask, _super);
    function CopyPixelTask() {
        var _this = _super.call(this) || this;
        _this.activateInternaly = false;
        _this._transformChanged = false;
        _this._focusId = -1;
        _this._colorTransformUData = EMPTY_TRANSFORM.slice();
        return _this;
    }
    Object.defineProperty(CopyPixelTask.prototype, "transform", {
        get: function () {
            return this._transform;
        },
        set: function (value) {
            if (this._transform === value && !value) {
                return;
            }
            this._transform = value;
            this._transformChanged = true;
            if (!value) {
                this._colorTransformUData.set(EMPTY_TRANSFORM);
            }
            else {
                var fd = this._colorTransformUData;
                fd.set(this.transform._rawData);
                for (var i = 0; i < 4; i++) {
                    fd[i + 4] /= 255;
                }
                // disable ALPHA offset, because can't allowed in PMA mode
                fd[7] = 0;
            }
        },
        enumerable: false,
        configurable: true
    });
    CopyPixelTask.prototype.getFragmentCode = function () {
        return FRAG;
    };
    CopyPixelTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var p = this._program3D;
        // const ctx = (<ContextWebGL> _stage.context)._texContext;
        p.uploadUniform('uTexMatrix', this._vertexConstantData);
        // upload only when a transfrom a REAL changed or after shader rebound
        if (this._transformChanged || p.focusId !== this._focusId) {
            this._focusId = p.focusId;
            this._transformChanged = false;
            p.uploadUniform('uColorTransform', this._colorTransformUData);
        }
    };
    return CopyPixelTask;
}(TaskBaseWebGL));
export { CopyPixelTask };
